import HorseList from './HorseList';
import HorseShow from './HorseShow';

export default {
  list: HorseList,
  show: HorseShow,
};
